export const MAIN_LAYER_CLASS_NAME = 'main-layer';
export const LABEL_LAYER_CLASS_NAME = 'label-layer';
export const ELEMENT_CLASS_NAME = 'element';
export const VIEW_CLASS_NAME = 'view';
export const PLOT_CLASS_NAME = 'plot';
export const COMPONENT_CLASS_NAME = 'component';
export const LABEL_CLASS_NAME = 'label';
export const AREA_CLASS_NAME = 'area';
export const MASK_CLASS_NAME = 'mask';
export const BREAK_CLASS_NAME = 'axis-breaks';
export const BREAK_GROUP_CLASS_NAME = 'axis-breaks-group';
//# sourceMappingURL=constant.js.map